import { RestRequestGetInitialMarginFractionOverride } from '@katanaperps/katana-perps-sdk';
import { skipToken, useQuery, useQueryClient } from '@tanstack/react-query';

import { getChainPrivateApi } from '#/api/apiCoreSdk';
import { minutes, seconds } from '#/api/queries/utils';
import { IGNORED_NONCE } from '#/config/constants';
import useEventCallback from '#/hooks/useEventCallback';

/**
 * Returns a stable callback which will require all trading rewards requests to be
 * refetched/refreshed.
 */
export function useInvalidateInitialMarginFractionOverrideQueries() {
  const queryClient = useQueryClient();

  const invalidate = useEventCallback(async () => {
    await queryClient.invalidateQueries({
      queryKey: ['initialMarginFractionOverrides'],
    });
  });

  return invalidate;
}

/** Get user leverages for all markets (For Wallet if unlocked) */
export function useInitialMarginFractionOverrideQueries({
  walletAddress,
  isVault,
}: {
  walletAddress: string;
  isVault: boolean;
}) {
  return useQuery({
    queryKey: [
      'initialMarginFractionOverrides',
      walletAddress || 'public',
      isVault,
    ],
    queryFn: !walletAddress
      ? skipToken
      : () => {
          const params: RestRequestGetInitialMarginFractionOverride = {
            nonce: IGNORED_NONCE,
            wallet: walletAddress,
          };
          return isVault
            ? getChainPrivateApi().getInternalInitialMarginFractionOverrideForVault(
                params
              )
            : getChainPrivateApi().getInitialMarginFractionOverride(params);
        },
    staleTime: seconds(25),
    refetchInterval: minutes(10),
  });
}
